module.exports = __webpack_public_path__ + "img/stitlew.94911f72.png";